import ModalWindow from "./ModalWindow.component";

export default ModalWindow;
